import React, { Component } from 'react';
import PropTypes from 'prop-types'
import * as types from '../../../constants/actionTypes';
import Drawer from '../../Common/Drawer/Drawer';
import LoadingIndicator from '../../Common/LoadingIndicator/LoadingIndicator';
import Notification from '../../Common/Notification';
import Icon from '../../Common/Icon';
import InputText from '../../Common/InputText';
import MultiSelectBox from '../../Common/MultiSelectBox/MultiSelectBox';
import Toggle from '../../Common/Toggle/Toggle';
import TextArea from '../../Common/TextArea';
import {
    DailyDigestPopover,
    WeeklyDigestPopover
} from '../../../constants/constants';
import './UserRequestDrawer.scss';
import { convertFromRaw } from 'draft-js';
import { stateToHTML } from 'draft-js-export-html';
import { isValidEmailAddress } from '../../../helpers/validation';

// From Dan Abramov himself: https://github.com/facebook/create-react-app/issues/679#issuecomment-266209431
import $ from 'jquery';
window.jQuery = $;
require('bootstrap')

export default class UserRequestDrawer extends Component {

    constructor(props, context) {
        super(props, context);

        const userRequest = {
            accessCode: '',
            subscriptionId: 0,
            isSubscriptionSSOEnabled: false,
            firstName: '',
            lastName: '',
            email: '',
            userName: '',
            jobTitle: '',
            employeeId: '',
            workPhone: '',
            countryId: '',
            managementCompanyId: '',
            communityIds: '',
            departmentIds: '',
            sendWeeklyEmail: false,
            sendDailyEmail: false,
            dayOfWeekId: '',
            hourOfDayId: '',
            locationId: '',
            additionalNotes: '',
            isSsoUser: false,
            approvedMessage: '',
            internalComment: ''
        }

        this.state = {
            isFormValid: true,
            isLoading: false,
            userRequest: userRequest,
            communities: [],
            countries: [],
            departments: [],
            managementCompanies: [],
            allLocations: [],
            availableLocations: [],
            specificJobTitles: [],
            hoursOfTheDay: [],
            daysOfTheWeek: []
        };

        this.dailyRef = React.createRef();
        this.weeklyRef = React.createRef();
    }

    componentDidMount = async () => {
        try {
            this.setState({ isLoading: true });
            await Promise.all([this.loadFilters(), this.loadUserAccessRequest()]);
        } catch (error) {
            Notification("error", "Error", error);
        } finally {
            this.setState({ isLoading: false });
        }

        $(this.dailyRef.current).popover();
        $(this.weeklyRef.current).popover();
    }

    componentDidUpdate = (prevProps) => {
        if (this.props.userAccessRequestId && (this.props.userAccessRequestId !== prevProps.userAccessRequestId)) {
            this.loadUserAccessRequest();
        }
    }

    onFormChange = (name, value) => {
        this.setState({ userRequest: { ...this.state.userRequest, [name]: value } });
    }

    onCancel = () => {
        this.setState({ isFormValid: true });
        this.props.onCancel();
    }

    loadUserAccessRequest = async () => {
        try {
            const response = await this.props.userAccessRequestActions.loadUserAccessRequest(this.props.userAccessRequestId);
            if (response.type === types.LOAD_USER_ACCESS_REQUEST_SUCCESS) {
                const request = response.payload.result;
                
                let communityIds = '';
                if (request.communityIds) {
                    communityIds = request.communityIds.join()
                }

                let departmentIds = '';
                if (request.departmentIds) {
                    departmentIds = request.departmentIds.join()
                }

                this.setState({
                    userRequest:
                    {
                        ...this.state.userRequest,
                        ...request,
                        isSsoUser: request.employeeId !== "",
                        managementCompanyId: request.managementCompanyId ? request.managementCompanyId.toString() : '',
                        countryId: request.countryId ? request.countryId.toString() : '',
                        locationId: request.locationId ? request.locationId.toString() : '',
                        dayOfWeekId: request.dayOfWeekId ? request.dayOfWeekId.toString() : '',
                        hourOfDayId: request.hourOfDayId >= 0 && request.hourOfDayId <= 23 ? request.hourOfDayId.toString() : '',
                        communityIds: communityIds,
                        departmentIds: departmentIds
                    }
                });
            } else if (response.type === types.LOAD_USER_ACCESS_REQUEST_FAILURE) {
                Notification("error", "An Error Occurred", response.payload.message);
            }
        } catch (error) {
            Notification("error", "Error", error);
        }
    }

    loadFilters = async () => {
        try {
            const response = await this.props.userAccessRequestActions.loadUpdateFilters(this.props.subscriptionId);
            if (response.type === types.LOAD_USER_REQUEST_UPDATE_FILTERS_SUCCESS) {
                this.setState({
                    communities: response.payload.communities,
                    countries: response.payload.countries,
                    departments: response.payload.departments,
                    managementCompanies: response.payload.managementCompanies,
                    allLocations: response.payload.locations,
                    availableLocations: response.payload.locations,
                    hoursOfTheDay: response.payload.hoursOfDay,
                    daysOfTheWeek: response.payload.daysOfWeek                    
                });
            } else if (response.type === types.LOAD_USER_REQUEST_UPDATE_FILTERS_FAILURE) {
                Notification("error", "An Error Occurred", response.payload.message);
            }
        } catch (error) {
            Notification("error", "Error", error);
        }
    }


    onSave = async () => {
        try {
            if (!this.validateForm()) {
                this.setState({ isFormValid: false });
                return;
            }

            this.setState({ isLoading: true });

            const userRequest = this.state.userRequest;
            let communityIds = [];
            if (userRequest.communityIds && userRequest.communityIds.trim().length > 0) {
                communityIds = userRequest.communityIds.split(',');
            }

            let departmentIds = [];
            if (userRequest.departmentIds && userRequest.departmentIds.trim().length > 0) {
                departmentIds = userRequest.departmentIds.split(',');
            }

            var request = {
                ...userRequest,
                communityIds: communityIds,
                departmentIds: departmentIds
            };

            const result = await this.props.userAccessRequestActions.update(request);
            if (result.type === types.UPDATE_USER_ACCESS_REQUEST_SUCCESS) {
                Notification("success", "Success", "User Access Request saved successfully");
                this.setState({ isFormValid: true });
                this.props.onComplete();
            } else if (result.type === types.UPDATE_USER_ACCESS_REQUEST_FAILURE) {
                Notification("error", "Error", result.payload.message);
                this.setState({ isLoading: false });
            }
        } catch (error) {
            Notification("error", "Error", error);
            this.setState({ isLoading: false });
        } finally {
            // Do not set isLoading state here. If the save was successful, the 
            // component is unloaded already because of the redirect
        }
    }

    onChange = (e) => {
        this.onFormChange(e.target.name, e.target.value);
    }

    onToggleChange = (name, value) => {

        //if SSO toggle is off then we need to clear out the employee Id value, otherwise toggle as usual
        if (name === 'isSsoUser' && value === false) {
            this.setState({ 
                userRequest: { 
                    ...this.state.userRequest, 
                    employeeId: "",
                    isSsoUser: false
                } 
            });
        } else {
            this.onFormChange(name, value);
        }

    }

    onMultiSelectChange = (value, name) => {
        this.onFormChange(name, value.toString());
    }

    onManagementCompanyChange = (value) => {
        const val = value.toString();
        const locations = this.state.allLocations.filter(x => x.managementCompanyId.toString() === val);

        let locationId = this.state.userRequest.locationId;
        const isSelectedLocationStillAvailable = locations.findIndex(x => x.id.toString() === locationId) >= 0;
        if (!isSelectedLocationStillAvailable) {
            locationId = ''; // Clear out selected location Id
        }

        this.setState({
            availableLocations: locations,
            userRequest: {
                ...this.state.userRequest,
                managementCompanyId: val,
                locationId: locationId
            }
        })
    }

    validateForm = () => {
        const {
            firstName,
            lastName,
            email,
            userName,
            jobTitle,
            employeeId,
            managementCompanyId,
            countryId,
            communityIds,
            locationId,
            isSubscriptionSSOEnabled,
            sendWeeklyEmail,
            dayOfWeekId,
            sendDailyEmail,
            hourOfDayId,
        } = this.state.userRequest;

        if (!(email && email.trim().length > 0 && isValidEmailAddress(email))) {
            Notification("error", 'Email address is not valid', '');
            return false;
        }

        return (
            firstName && firstName.trim().length > 0
            && lastName && lastName.trim().length > 0
            && userName && userName.trim().length > 0
            && jobTitle && jobTitle.trim().length > 0
            && managementCompanyId && managementCompanyId.trim().length > 0
            && countryId && countryId.trim().length > 0
            && communityIds && communityIds.trim().length > 0
            && locationId && locationId.trim().length > 0
            && (!isSubscriptionSSOEnabled || (isSubscriptionSSOEnabled && employeeId && employeeId.trim().length > 0))
            && (!sendWeeklyEmail || (sendWeeklyEmail && dayOfWeekId && dayOfWeekId.trim().length > 0))
            && (!sendDailyEmail || (sendDailyEmail && hourOfDayId && hourOfDayId.trim().length > 0))
        );
    }

    onApproveUserRequest = async () => {
        try {
            if (!this.validateForm()) {
                this.setState({ isFormValid: false });
                return;
            }

            this.setState({ isLoading: true });

            const userRequest = this.state.userRequest;
            let communityIds = [];
            if (userRequest.communityIds && userRequest.communityIds.trim().length > 0) {
                communityIds = userRequest.communityIds.split(',');
            }

            let departmentIds = [];
            if (userRequest.departmentIds && userRequest.departmentIds.trim().length > 0) {
                departmentIds = userRequest.departmentIds.split(',');
            }

            const jsonContent = JSON.parse(userRequest.approvedMessage);
            const contentState = convertFromRaw(jsonContent);
            const approvedMessageHTML = stateToHTML(contentState);

            var request = {
                ...userRequest,
                communityIds: communityIds,
                departmentIds: departmentIds,
                isApproved: true,
                approvedMessageHTML: approvedMessageHTML
            };

            const result = await this.props.userAccessRequestActions.approve(request);
            const payload = result.payload;
            if (result.type === types.APPROVE_USER_ACCESS_REQUEST_SUCCESS) {
                Notification("success", "Success", "User Access Request successfully approved");
                this.props.onComplete();
            } else if (result.type === types.APPROVE_USER_ACCESS_REQUEST_FAILURE) {
                Notification("error", "An Error Occurred", payload.message)
                this.setState({ isLoading: false });
            }
        } catch (error) {
            Notification("error", "An Error Occurred", error);
            this.setState({ isLoading: false });
        }
    }

    onDenyUserRequest = async () => {
        try {
            const result = await this.props.userAccessRequestActions.deny(this.props.userAccessRequestId, this.props.subscriptionId);
            const payload = result.payload;
            if (result.type === types.DENY_USER_ACCESS_REQUEST_SUCCESS) {
                Notification("success", "Success", "User Access Request successfully denied");
                this.props.onComplete();
            } else if (result.type === types.DENY_USER_ACCESS_REQUEST_FAILURE) {
                Notification("error", "An Error Occurred", payload.message)
            }
        } catch (error) {
            Notification("error", "An Error Occurred", error);
        }
    }

    render() {
        const valid = this.state.isFormValid ? "user-request-form" : "user-request-form was-validated";
        const className = "user-profile-set-form " + valid;

        const formButtons = [
            <button key="approve" type="button" className="btn btn-light button--approveUserRequest" onClick={this.onApproveUserRequest}>Approve</button>,
            <button key="deny" type="button" className="btn btn-light button--denyUserRequest" onClick={this.onDenyUserRequest}>Deny</button>
        ];

        return (
            <Drawer isWide={true} title="Edit User Access Request"
                onSaveClick={this.onSave}
                onCancelClick={this.onCancel}
                saveText='Save and Close'
                formButtons={formButtons}
            >
                <LoadingIndicator isLoading={this.state.isLoading}>

                    <form className={className} noValidate>
                        <div className="row">
                            <div className="col-md-6">
                                <InputText name="firstName" label="First Name" placeholder="First Name" type="text" value={this.state.userRequest.firstName} onChange={this.onChange} isRequired={true} errorMessage="First Name is required" />
                                <InputText name="lastName" label="Last Name" placeholder="Last Name" type="text" value={this.state.userRequest.lastName} onChange={this.onChange} isRequired={true} errorMessage="Last Name is required" />
                                <InputText name="email" label="Email" placeholder="Email" type="text" value={this.state.userRequest.email} onChange={this.onChange} isRequired={true} errorMessage="Email is required" />
                                <InputText name="userName" label="UserName" placeholder="UserName" type="text" value={this.state.userRequest.userName} onChange={this.onChange} isRequired={true} errorMessage="UserName is required" />
                                <InputText name="jobTitle" label="Job Title/Role" placeholder="Job Title/Role" type="text" value={this.state.userRequest.jobTitle} onChange={this.onChange} isRequired={true} errorMessage="Job Title is required" />
                                <InputText name="workPhone" label="Work Phone" placeholder="Work Phone" type="text" value={this.state.userRequest.workPhone} onChange={this.onChange} />

                                <div className="toggle-wrapper">
                                    <Toggle name="sendDailyEmail" text="Daily Digest" checked={this.state.userRequest.sendDailyEmail} onChange={this.onToggleChange} />
                                    <div ref={this.dailyRef}
                                        id="daily-popover"
                                        className="toggle-tip"
                                        data-toggle="popover"
                                        title={DailyDigestPopover.Title}
                                        data-placement="bottom"
                                        data-content={DailyDigestPopover.Body}
                                    >
                                        <Icon name="info-circle" />
                                    </div>
                                </div>
                                {
                                    this.state.userRequest.sendDailyEmail
                                        ?
                                        <MultiSelectBox name="hourOfDayId" label="Send daily notifications around this time of day (UTC)" idField="id" valueField="name"
                                            options={this.state.hoursOfTheDay}
                                            selectedValues={this.state.userRequest.hourOfDayId.toString()}
                                            onChange={this.onMultiSelectChange}
                                            isRequired={this.state.userRequest.sendDailyEmail}
                                            errorMessage="An hour must be selected"
                                            isMulti={false}
                                        />
                                        :
                                        null
                                }

                                <div className="toggle-wrapper">
                                    <Toggle name="sendWeeklyEmail" text="Weekly Digest" checked={this.state.userRequest.sendWeeklyEmail} onChange={this.onToggleChange} />
                                    <div ref={this.weeklyRef}
                                        className="toggle-tip"
                                        data-toggle="popover"
                                        title={WeeklyDigestPopover.Title}
                                        data-placement="bottom"
                                        data-content={WeeklyDigestPopover.Body}
                                    >
                                        <Icon name="info-circle" />
                                    </div>
                                </div>

                                {
                                    this.state.userRequest.sendWeeklyEmail
                                        ?
                                        <MultiSelectBox name="dayOfWeekId" label="Send Weekly notifications on this day" idField="id" valueField="name"
                                            options={this.state.daysOfTheWeek}
                                            selectedValues={this.state.userRequest.dayOfWeekId.toString()}
                                            onChange={this.onMultiSelectChange}
                                            isRequired={this.state.userRequest.sendWeeklyEmail}
                                            errorMessage="A day must be selected"
                                            isMulti={false}
                                        />
                                        :
                                        null
                                }
                            </div>

                            <div className="col-md-6">
                                <MultiSelectBox name="managementCompanyId" label="Management Company" idField="id" valueField="name"
                                    options={this.state.managementCompanies}
                                    onChange={this.onManagementCompanyChange}
                                    defaultValue="Select a Management Company"
                                    selectedValues={this.state.userRequest.managementCompanyId.toString()}
                                    isRequired={true}
                                    errorMessage="Management Company is required"
                                    isMulti={false}
                                />

                                <MultiSelectBox name="countryId" label="Country" idField="id" valueField="name"
                                    options={this.state.countries}
                                    onChange={this.onMultiSelectChange}
                                    defaultValue="Select a Country"
                                    selectedValues={this.state.userRequest.countryId.toString()}
                                    isRequired={true}
                                    errorMessage="Country is required"
                                    isMulti={false}
                                />

                                <MultiSelectBox name="communityIds" label="Communities" idField="id" valueField="name"
                                    options={this.state.communities}
                                    selectedValues={this.state.userRequest.communityIds.toString()}
                                    onChange={this.onMultiSelectChange}
                                    isRequired={true}
                                    errorMessage="At least one Community must be selected"
                                    isMulti={true}
                                />

                                <MultiSelectBox name="departmentIds" label="Favorite Departments" idField="id" valueField="name"
                                    options={this.state.departments}
                                    selectedValues={this.state.userRequest.departmentIds.toString()}
                                    onChange={this.onMultiSelectChange}
                                    isMulti={true}
                                />

                                <MultiSelectBox name="locationId" label="Requested Location" idField="id" valueField="name"
                                    options={this.state.availableLocations}
                                    onChange={this.onMultiSelectChange}
                                    defaultValue="Select a Location"
                                    selectedValues={this.state.userRequest.locationId.toString()}
                                    isRequired={true}
                                    errorMessage="Requested Location is required"
                                    isMulti={false}
                                />

                                <TextArea rows={2} name="additionalNotes" placeholder="Additional Notes" label="Additional Notes" value={this.state.userRequest.additionalNotes} onChange={this.onChange} />

                                <TextArea rows={5} name="internalComment" label="Internal Comment" placeholder="Internal Comment" value={this.state.userRequest.internalComment} onChange={this.onChange} maxLength={1000} />
                                <div className="remaining-chars text-end">{this.state.userRequest.internalComment.length}/1000</div>

                                {this.state.userRequest.isSubscriptionSSOEnabled === true && 
                                    <div className="row toggle-wrapper">
                                        <Toggle name="isSsoUser" text="SSO User" checked={this.state.userRequest.isSsoUser} onChange={this.onToggleChange} />
                                    </div>
                                }

                                {this.state.userRequest.isSsoUser &&
                                    <InputText name="employeeId" label="Employee ID" placeholder="Employee ID" type="text" value={this.state.userRequest.employeeId} onChange={this.onChange} isRequired={true} errorMessage="Employee ID is required" />
                                }

                            </div>
                        </div>
                    </form>
                </LoadingIndicator>
            </Drawer >
        )
    }
}

UserRequestDrawer.propTypes = {
    subscriptionId: PropTypes.string.isRequired,
    userAccessRequestId: PropTypes.string.isRequired,
    onComplete: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    userAccessRequestActions: PropTypes.object.isRequired
};
